<div id="layout" class="theme-cyan">
  <app-event-leftmenu></app-event-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Event Members</h5>
                  </div>
                  <small class="text-truncate text-muted">(last update 1hr ago) total 245</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>


      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar1.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Michelle Green</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar2.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Charlotte Green</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar3.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Susie Willis</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar4.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Daniel Kristeen</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar5.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Jason Porter</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar6.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Darryl Day</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">523 Williams St, Kingsville, TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar7.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Jane Hunt</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">1994 W Ludington Dr, Farwell, TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar8.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Daniel Kristeen</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">523 Williams St, Kingsville, TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar9.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Amelia Green</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">392 W Clark St, East Palestine OH, 44413</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar10.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Daniel Kristeen</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">523 Williams St, Kingsville,TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar4.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Daniel Kristeen</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar5.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Jason Porter</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">2126 Pecan Rd, Pass Christian, MS, 39571</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar6.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Darryl Day</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">523 Williams St, Kingsville, TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar7.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h6 class="mb-1"><a href="javascript:void(0)">Jane Hunt</a></h6>
                      <!-- Text -->
                      <p class="small text-muted mb-1">1994 W Ludington Dr, Farwell, TX, 78363</p>
                      <!-- Status -->
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                          dropdownToggle type="button" aria-controls="dropdown-alignment">
                          <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                        </a>
                        <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-alignment">
                          <a href="javascript:void(0)" class="dropdown-item">Action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>
          </div> <!-- / .row -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
